import React, { useContext } from 'react';

import { useLocations } from '@hooks';
import { SiteContext } from '@context';

import { ContactLocationsContainer } from './styles';

const ContactLocations = () => {
  const locations = useLocations();
  const { dispatch } = useContext(SiteContext);

  return (
    <ContactLocationsContainer
      className="contact_locations"
      length={locations.length}
    >
      <div className="contact_locations__content">
        <h2 className="contact_locations__heading">Contact Accident Legal</h2>
        <div className="contact_locations__content__row">
          {locations.map(({ name, address }) => (
            <div key={name} className="contact_locations__content__item">
              <h3
                title={`Show Google map for ${name}`}
                role="button"
                onClick={() =>
                  dispatch({ type: 'CHANGE_LOCATION', payload: name })
                }
              >
                {name}
              </h3>
              <pre>{address}</pre>
            </div>
          ))}
        </div>
      </div>
    </ContactLocationsContainer>
  );
};

export { ContactLocations };
